import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TwoFactorAuthService, TwoFactorMethod } from '@capturum/auth';

@Component({
  selector: 'emc-auth-sms',
  templateUrl: './auth-sms.component.html',
})
export class AuthSmsComponent implements OnInit {
  @Input()
  public smsCodeShown: boolean;

  @Input()
  public paragraphNumbers: Record<string, number>;

  @Input()
  public method: TwoFactorMethod = TwoFactorMethod.sms;

  @Output()
  public smsCodeEvent: EventEmitter<boolean> = new EventEmitter();

  public smsForm: FormGroup;
  public smsSent: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authService: TwoFactorAuthService,
  ) {
  }

  public ngOnInit(): void {
    this.smsForm = this.formBuilder.group({
      phoneNumber: [
        null,
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
        ],
      ],
    });

    this.authService.setupSms().subscribe((response) => {
      if (response?.identifier) {
        this.smsForm.patchValue({ phoneNumber: response.identifier });
      }
    });
  }

  public submit(): void {
    if (this.smsForm.valid) {
      this.authService.register('sms', this.smsForm.value.phoneNumber).subscribe(() => {
        this.smsCodeEvent.emit(true);
        this.smsSent = true;
      });
    }
  }
}
